module.exports = __webpack_public_path__ + "static/scale-model-of-louisiana-folks-roots,-inc.-in-lafayette-louisiana-a9fdcb89863512f5d272534f6cfe8fa9.png";